import { useEffect, useState } from 'react';

const useReviewStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        // Store-wide rating, same source as the homepage widget.
        const response = await fetch('https://api.reviews.io/merchant/reviews?store=weriise.co&per_page=1');
        const data = await response.json();
        setStats(
          data?.stats
            ? { count: data.stats.total_reviews, average: data.stats.average_rating }
            : null,
        );
      } catch (error) {
        setStats(null);
      }
    };

    fetchReviews();
  }, []);

  return stats;
};

export default useReviewStats;
